
import Vue from "vue";
import { adminUnsubscribeUser } from "@/api";

interface UserInfo {
  id: number;
  email: string;
  hygienistId?: number;
  dentistId?: number;
}

interface UnsubscribeResult {
  success: boolean;
  message: string;
  userEmail: string;
  userId: number;
  mailChimpUnsubscribed: boolean;
}

export default Vue.extend({
  name: "UnsubscribeDialog",
  data() {
    return {
      dialog: false,
      confirmed: false,
      loading: false,
      errorMessage: "",
      successResult: null as UnsubscribeResult | null,
      userInfo: {
        id: 0,
        email: "",
        hygienistId: undefined,
        dentistId: undefined
      } as UserInfo
    };
  },
  methods: {
    openDialog(userInfo: UserInfo) {
      this.userInfo = userInfo;
      this.dialog = true;
      this.confirmed = false;
      this.loading = false;
      this.errorMessage = "";
      this.successResult = null;
    },

    closeDialog() {
      this.dialog = false;
      this.userInfo = {
        id: 0,
        email: "",
        hygienistId: undefined,
        dentistId: undefined
      };
      this.confirmed = false;
      this.loading = false;
      this.errorMessage = "";
      this.successResult = null;
    },

    async unsubscribeUser() {
      if (!this.confirmed || !this.userInfo.id) {
        return;
      }

      this.loading = true;
      this.errorMessage = "";

      try {
        console.log(
          "📧 UnsubscribeDialog: Unsubscribing user:",
          this.userInfo.id
        );

        const result = await adminUnsubscribeUser(this.userInfo.id);

        console.log("📧 UnsubscribeDialog: Unsubscribe successful:", result);

        this.successResult = result;

        // Emit success event to parent component
        this.$emit("unsubscribe-success", {
          userId: this.userInfo.id,
          result: result
        });
      } catch (error) {
        console.error("📧 UnsubscribeDialog: Unsubscribe failed:", error);
        this.errorMessage =
          error instanceof Error
            ? error.message
            : "Unsubscribe failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getUserType(userInfo: UserInfo): string {
      if (userInfo.hygienistId) {
        return "Dental Professional";
      } else if (userInfo.dentistId) {
        return "Dental Office";
      }
      return "Unknown";
    }
  }
});
